﻿$.fn.dxCtrlFileUploaderGeneral = function custom_dxCtrlFileUploaderGeneral(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfileuploadergeneral dx-ctrl");
        this.createInstance(new cdxCtrlFileUploaderGeneral(this, option));
    }
    return this;
}

window.cdxCtrlFileUploaderGeneral = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.machine == "undefined") option.machine = true
    if (typeof option.box == "undefined") option.box = true
    if (typeof option.imgInternet == "undefined") option.imgInternet = false
    if (typeof option.imgPexel == "undefined") option.imgPexel = false
    if (typeof option.icone == "undefined") option.icone = false
    if (typeof option.docCpt == "undefined") option.docCpt = false
    if (typeof option.courrier == "undefined") option.courrier = false
    if (typeof option.camera == "undefined") option.camera = false
    if (typeof option.selectedItem == "undefined") {
        if (option.machine) { option.selectedItem = "machine" }
        else if (option.box) { option.selectedItem = "box" }
        else if (option.imgInternet) { option.selectedItem = "imginternet" }
        else if (option.imgPexel) { option.selectedItem = "imgpexel" }
        else if (option.icone) { option.selectedItem = "icone" }
        else if (option.docCpt) { option.selectedItem = "doccpt" }
        else if (option.courrier) { option.selectedItem = "courrier" }
        else if (option.camera) { option.selectedItem = "camera" }
    }

    var $DivBody = null
    function mConstruit() {
        container.empty();
        container.css({ height: "100%", width: "100%" })

        if (!option.bddCtrl.objCptCli.objetMetier.hasBox()) option.box = false
        if (!option.bddCtrl.objCptCli.objetMetier.hasDocCpt()) option.docCpt = false
        if (!option.bddCtrl.objCptCli.objetMetier.hasCourrier()) option.courrier = false

        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var dsTab = [{
            id: "machine",
            text: "Ordinateur",
            visible: option.machine
        }, {
            id: "box",
            text: "Box",
            visible: option.box
        }, {
            id: "imginternet",
            text: "Internet",
            visible: option.imgInternet
        }, {
            id: "imgpexel",
            text: "Pexels images",
            visible: option.imgPexel
        }, {
            id: "icone",
            text: "Icône",
            visible: option.icone
        }, {
            id: "doccpt",
            text: "Doc. Comptable",
            visible: option.docCpt
        }, {
            id: "courrier",
            text: "Courrier",
            visible: option.courrier
        }, {
            id: "camera",
            text: "Caméra",
            visible: option.camera
        }]

        var selectedItem = dsTab.filter(function (o) { return o.id == option.selectedItem })[0]
        var dxTabs = $("<div/>").appendTo($Td).dxTabs({
            dataSource: dsTab,
            selectedItem: selectedItem,
            width: "100%",
            //itemTemplate: function (itemData, itemIndex, itemElement) {
            //    itemElement.text(itemData.text)
            //    itemElement.css("overflow","hidden")
            //},
            onItemClick: function (e) {
                mRempli(e.itemData)
            }
        })

        if (typeof option.popup != 'undefined' && option.popup != null) {
            var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
            if (!parametre.isMobile) {
                var dxBtMax = $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: 'fas fa-window-maximize',
                    width: HeightButton,
                    height: HeightButton,
                    onClick: function (e) {
                        dxBtMax.element().hide()
                        dxBtMin.element().show()
                        option.popup.option("fullScreen", true)
                    }
                }).dxCtrlButton("instance");
                var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
                var dxBtMin = $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: 'fas fa-window-minimize',
                    width: HeightButton,
                    height: HeightButton,
                    onClick: function (e) {
                        dxBtMax.element().show()
                        dxBtMin.element().hide()
                        option.popup.option("fullScreen", false)
                    }
                }).dxCtrlButton("instance");
                dxBtMin.element().hide()
            }
            var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
            var dxBtClose = $("<div/>").appendTo($Td).dxCtrlButton({
                icon: 'fas fa-times',
                width: HeightButton,
                height: HeightButton,
                onClick: function (e) {
                    if (typeof option.popup.option != 'undefined') {
                        option.popup.hide();
                    } else {
                        option.popup.slideUp(300, function () { option.popup.remove() })
                    }
                }
            }).dxCtrlButton("instance");
        }

        $DivBody = $("<div style='height:calc(100% - " + $Table.innerHeight() + "px)'/>").appendTo(container)
        resizeObserver.mAdd($Table, function () { $DivBody.css("height", "calc(100% - " + $Table.innerHeight() + "px)") })

        mRempli(selectedItem)

    }

    var currentDx = null
    var currentItemData = null
    function mRempli(itemData) {
        $DivBody.empty()
        var identique = (currentItemData != null && currentItemData.id == itemData.id)
        currentItemData = itemData
        var $DivCtrl = $("<div style='width:100%;height:100%;'/>").appendTo($DivBody);
        switch (itemData.id) {
            case "machine":
                if (typeof option.optionUploader == 'undefined') option.optionUploader = {
                    bddCtrl: option.bddCtrl
                }
                option.optionUploader.onValide = function (lstFile) {
                    var lstUrlFile = []
                    lstFile.forEach(function (o) { lstUrlFile.push(o.url) })
                    option.onValide(lstUrlFile)
                }
                option.optionUploader.multiple = option.multiple
                option.optionUploader.accept = option.accept
                currentDx = $DivCtrl.dxCtrlFileUploaderMachine(option.optionUploader).dxCtrlFileUploaderMachine("instance");
                if (identique) currentDx.mSelectionneFichier()
                break;
            case "box":
                if (parametre.isMobile) {
                    currentDx = $DivCtrl.dxCtrlTreeViewFileManagerMobile({
                        bddCtrl: option.bddCtrl,
                        accept: option.accept,
                        hideNewBox: true,
                        allowRepertoirePublic: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoirePublic),
                        allowRepertoirePartage: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoirePartage),
                        allowRepertoireUti: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoireUti),
                        multiple: false,
                        onClickFile: function (url) {
                            option.onValide([url])
                        }
                    }).dxCtrlTreeViewFileManagerMobile("instance");
                } else {
                    currentDx = $DivCtrl.dxCtrlFileUploaderBox({
                        bddCtrl: option.bddCtrl,
                        accept: option.accept,
                        hideNewBox: true,
                        allowRepertoirePublic: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoirePublic),
                        allowRepertoirePartage: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoirePartage),
                        allowRepertoireUti: ((typeof option.optionBox == 'undefined') ? true : option.optionBox.allowRepertoireUti),
                        multiple: option.multiple,
                        onValide: option.onValide
                    }).dxCtrlFileUploaderBox("instance");
                }
                break;
            case "imginternet":
                if (typeof option.optionImgInternet == 'undefined') option.optionImgInternet = {
                    bddCtrl: option.bddCtrl
                }
                option.optionImgInternet.onValide = option.onValide
                option.optionImgInternet.multiple = option.multiple
                currentDx = $DivCtrl.dxCtrlFileUploaderImgInternet(option.optionImgInternet).dxCtrlFileUploaderImgInternet("instance");
                break;
            case "imgpexel":
                if (typeof option.optionImgPexel == 'undefined') option.optionImgPexel = {
                    bddCtrl: option.bddCtrl
                }
                option.optionImgPexel.onValide = option.onValide
                option.optionImgPexel.multiple = option.multiple
                option.optionImgPexel.isPexel = true
                currentDx = $DivCtrl.dxCtrlFileUploaderImgInternet(option.optionImgPexel).dxCtrlFileUploaderImgInternet("instance");
                break;
            case "icone":
                currentDx = $DivCtrl.dxCtrlFileUploaderIcone({
                    bddCtrl: option.bddCtrl,
                    multiple: option.multiple,
                    onValide: option.onValide
                }).dxCtrlFileUploaderIcone("instance");
                break;
            case "doccpt":
                currentDx = $DivCtrl.dxCtrlFileUploaderDocCpt({
                    bddCtrl: option.bddCtrl,
                    multiple: option.multiple,
                    onValide: option.onValide
                }).dxCtrlFileUploaderDocCpt("instance");
                break;
            case "courrier":
                currentDx = $DivCtrl.dxCtrlFileUploaderCourrier({
                    bddCtrl: option.bddCtrl,
                    multiple: option.multiple,
                    onValide: option.onValide
                }).dxCtrlFileUploaderCourrier("instance");
                break;
            case "camera":
                currentDx = $DivCtrl.dxCtrlFileUploaderCamera({
                    bddCtrl: option.bddCtrl,
                    multiple: option.multiple,
                    onValide: option.onValide
                }).dxCtrlFileUploaderCamera("instance");
                break;
        }
    }

    this.element = function () { return container }

    mConstruit();
}